import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { initAnalytics } from "./analytics/analytics";
import { applyMarketingRedirect } from "./marketingRedirects";

applyMarketingRedirect();
initAnalytics();
document.documentElement.removeAttribute("data-twap-private-route");

// StrictMode выключен в dev — он двойным mount'ом аборт'ил in-flight fetch'и
// в TickerStatsModal (timeoutMs 30s + второй вызов effect успевал отменить
// первый). Прод-сборка уже без двойного mount по умолчанию.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <App />
);
